import React from 'react';
import { Card, Input } from '@avila-tek/ui/src';
import { Benefit } from '../../models';
import { FormHeader } from '../shared/Forms';

interface BenefitFormProps {
  benefit?: Partial<Benefit>;
  setBenefit?: React.Dispatch<
    React.SetStateAction<Partial<Benefit> | undefined>
  >;
}

function BenefitForm({ benefit, setBenefit }: BenefitFormProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { id, value } = e.target;
    setBenefit((prevBenefit) => ({
      ...prevBenefit,
      [id]: id === 'value' ? Number(value) : value, // Handle number conversion for value
    }));
  };

  return (
    <Card>
      <FormHeader title="Beneficio general" backBtnText="Beneficios" />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Input
              id="title"
              value={benefit?.title ?? ''} // Use benefit?.title for initial value
              label="Nombre"
              type="text"
              placeholder="Ingrese el nombre del beneficio"
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full">
            <Input
              id="value"
              value={benefit?.value?.toString() ?? ''} // Use benefit?.value for initial value and convert to string
              label="Valor"
              type="number"
              placeholder="Ingrese Valor"
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default BenefitForm;
